import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { VisualizationWidgetGitFactoryService } from './visualization-widget-git-factory.service';
import { VisualizationWidgetState } from './visualization-widget-state.model';

const initialState: VisualizationWidgetState = {
  loading: true,
  last_used: {},
  starred: {},
  ui: {},
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'visualization-widget', idKey: '$path' })
export class VisualizationWidgetStore extends AbstractFeatureEntityStore<VisualizationWidgetState> {
  constructor(protected readonly gitFactory: VisualizationWidgetGitFactoryService) {
    super({ name: 'Visualization-Widget', gitFactory, initialState });
  }
}
